// Self-hosted Umami analytics tracker (reuses the rwm-portal instance on
// analytics.rawmechatronics.com). Config is baked at build time from
// REACT_APP_UMAMI_* (see Dockerfile / soft-infra/hiljuris/.env).
// The tracker is injected only when a website id is present, so local/dev
// builds without the vars stay clean.
const src = process.env.REACT_APP_UMAMI_SRC;
const websiteId = process.env.REACT_APP_UMAMI_WEBSITE_ID;

if (src && websiteId) {
  const script = document.createElement('script');
  script.defer = true;
  script.src = src;
  script.setAttribute('data-website-id', websiteId);
  document.head.appendChild(script);
}
